import { Component, OnInit, Input, inject, signal } from '@angular/core';
import { settledCache$ } from '../../shared/utils/cache-ready';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { filter, take } from 'rxjs';

import { Contract } from '../../objects/contract';
import { ContractService } from '../../service/entity-services/contract.service';

@Component({
  selector: 'app-contract-connections',
  templateUrl: './contract-connections.component.html',
  styleUrls: ['./contract-connections.component.css'],
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, MatChipsModule, MatProgressSpinnerModule]
})
export class ContractConnectionsComponent implements OnInit {
  private contractService = inject(ContractService);
  private router = inject(Router);

  contractObjectArray = signal<Contract[]>([]);
  waiting = signal<boolean>(true);

  @Input() selectedContractList: any[] = [];

  ngOnInit(): void {
    this.hydrateContractData();
  }

  private hydrateContractData(): void {
    if (!this.selectedContractList || this.selectedContractList.length === 0) {
      this.waiting.set(false);
      return;
    }

    this.waiting.set(true);

    // Extract contract identifiers, dedup
    const contractIds = Array.from(new Set(
      this.selectedContractList.map(c =>
        typeof c === 'object' && c?.contractId ? c.contractId :
        typeof c === 'object' && c?.contractNum ? c.contractNum : c
      ).filter(id => !!id)
    ));

    if (contractIds.length === 0) {
      this.waiting.set(false);
      return;
    }

    // Wait for the contract cache to FINISH streaming before looking up.
    // `filter(arr => arr.length > 0)` resolved on page 1, so any linked contract
    // on a later page was dropped by the .find() below and silently vanished
    // from the tab — the list looked complete while being wrong.
    settledCache$(this.contractService.allContracts$).subscribe({
      next: (allContracts) => {
        const matched = contractIds
          .map(id => allContracts.find(c => c.contractId === id || c.contractNum === id))
          .filter((c): c is Contract => c !== null && c !== undefined);
        this.contractObjectArray.set(matched);
        this.waiting.set(false);
      },
      error: (err) => {
        console.error('Error loading contract connections:', err);
        this.waiting.set(false);
      }
    });
  }

  navigateToContract(contract: Contract): void {
    const num = contract.contractNum || contract.contractId;
    if (num) {
      window.open(`/securehome/contract/${num}`, '_blank');
    }
  }

  formatDate(date: string | undefined): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString();
  }
}
